<template>
  <div class="d-flex app-wrapper">

  <!-- MODAL DE CONVITE -->
    <modal v-if="showModal" class="modal-invited" @close="showModal = false">
      <div slot="header">
        <div class="tit float-left">
          <h2>
            <i class="icon icon-airplane xl"></i>
            Enviar Convite
          </h2>
        </div>
      </div>
      <div slot="body">
          <section class="row">
            <!-- <div class="col-12 col-md-3">
              <a href="#" class="btn btn-primary invited-person active" @click="modalStep = 1, activeButton('person'), auxModalStep = 1">
                Convidar amigo
              </a>
            </div> -->
            <div class="col-12 col-md-3">
              <a href="#" class="btn btn-primary invited-company" @click="modalStep = 2, activeButton('company'), auxModalStep = 2">
                Convidar empresa
              </a>
            </div>
          </section>
          <section class="row">
              <div class="col-12">
                <h3>
                  Convite por email
                </h3>
              <!-- FORMULARIO CONVIDAR AMIGO -->
              <friend v-if="modalStep === 1" v-on:finished="finishInvite()"/>
              <!-- :::::::::::: -->
              <!-- FORMULARIO CONVIDAR EMPRESA -->
              <company v-else-if="modalStep === 2" v-on:finished="finishInvite()" />
              <!-- ::::::::::::: -->
              <!-- STEP DE MENSAGEM ENVIADA DE SUCESSO -->
              <div v-else-if="modalStep === 3" class="success d-flex flex-column justify-content-center align-items-center">
                <i class="icon icon-success xll"></i>
                <h3>
                  Seu convite foi enviado com sucesso!
                </h3>
                <a href="javascript:;" v-on:click.prevent="modalStep = auxModalStep" class="btn btn-primary">
                  enviar novamente
                </a>
              </div>
              <!-- ::::::::::::::::: -->
            </div>
          </section>
      </div>
    </modal>
    <!-- ::::::::::: -->

	<!-- MODAL ALTERNAR INVESTIMENTO -->
	<div class="modal modal__bootstrap fade" id="modalMotivo" tabindex="-1" role="dialog" aria-labelledby="modalMotivo" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal__bootstrap-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal__bootstrap-body">
					<div>
						<h2>Ir para investimentos</h2>
						<img src="/static/assets/images/tomador.svg" class="image" alt="">
						<p>Você está prestes a ir para a área de <strong>Investidores</strong>.<br>A partir da área de investimentos não é possível solicitar empréstimo, nem acompanhar o processo de soliticação de empréstimo.<br>Tem certeza que deseja mudar de ambiente?</p>
						<button class="btn btn-lg btn-secondary" data-dismiss="modal" aria-label="Close">Continuar em empréstimo</button>
						<router-link to='/investimentos/oportunidades' class="btn btn-lg btn-primary" data-dismiss="modal">Ir para Investimentos <img src="/static/assets/images/seta-modal.svg" width="16"></router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- FINAL MODAL ALTERNAR INVESTIMENTO -->

    <SideMenu :items="menuItems" :tipo="'emprestimos'"/>
    <div class="bg"></div>
    <div class="wrapper d-flex flex-column">
      <header class="head row d-flex justify-content-between">
        <div class="col-12 col-sm-12 col-md-6 col-lg-5 iouu">
          <a href="/" class="link" title="IOUU">
						<i class="ico-iouu" />
					</a>
          <p>
            <span>Seja bem-vindo à plataforma IOUU</span>


            Esse é seu dashboard. Aqui você poderá acompanhar o status
            de sua soliticação de empréstimo, emitir seus boletos e ficar por dentro
            das novidades da IOUU.
          </p>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-7 ">


          <!-- MENU TOP HEADER MOBILE -->
           <div class="d-flex justify-content-between util mob">
             <div class="mob-menu">
               <a @click="ShowMobMenu(true);" class="btn">
                 <i class="fas fa-bars"></i>
               </a>
             </div>
             <div class="mob-logo">
               	<a href="/" class="link" title="IOUU">
                  <i class="ico-iouu" />
                </a>
             </div>
             <div class="mob-profile">
               <!-- ALERTA MOBILE -->
               <alerts :from="from" tipoUsuario="emprestimos"></alerts>
               <!-- ::::::::::::: -->
              <div class="user">
                <at-dropdown placement="bottom-right">
                  <router-link :to="{ path: '/emprestimos/perfil/configuracoes' }" tag="div">
                    <div class="no-image rounded-circle">{{LetraNome()}}</div>
                  </router-link>
                </at-dropdown>
                <div class="exit">
                  <a href="#" title="Sair" v-on:click='Logout'><i class="ico-exit"></i></a>
                </div>
              </div>
             </div>
           </div>
          <!-- :::::i:::::::: -->

          <!-- MENU TOP HEADER -->
          <div class="d-flex justify-content-end util">
            <!-- <div class="invite" >
              <a href="#" id="show-modal" @click="showModal = true" title="Convidar amigo"><i class="ico-ps-2"></i> Convidar amigo</a>
            </div> -->

            <!-- ALERTA -->
           <alerts :from="from" tipoUsuario="emprestimos"></alerts>
           <!-- ::::::::::: -->


            <div class="user">
                <at-dropdown placement="bottom-right">
                  <div class="no-image rounded-circle">{{LetraNome()}}</div>
                  <!-- <img src="../../assets/images/liza.jpg" width="35" height="35" class="rounded-circle" alt=""> --><span>Olá, <strong>{{Nome()}}</strong> <i class="icon icon-chevron-down"></i></span>

                  <at-dropdown-menu slot="menu">

                  <at-dropdown-item > <router-link :to="{ path: '/emprestimos/notificacoes' }" tag="div">Minhas Notificações</router-link></at-dropdown-item>
                  <at-dropdown-item > <router-link :to="{ path: '/emprestimos/meus-emprestimos' }" tag="div">Meus Empréstimos</router-link></at-dropdown-item>
                  <at-dropdown-item > <router-link :to="{ path: '/emprestimos/historico' }"  tag="div">Meu Histórico</router-link></at-dropdown-item>
                  <at-dropdown-item divided > <router-link :to="{ path: '/emprestimos/perfil/dados-pessoais' }" tag="div">Meu perfil</router-link></at-dropdown-item>



                  </at-dropdown-menu>
                </at-dropdown>
              </div>

          <!-- .news  -->
          <!-- <div class="news">
            <a href="#" class="beamerTrigger"><i class="fas fa-fire"></i> Novidades</a>
          </div> -->

            <div class="exit">
               <a href="#" title="Sair" v-on:click='Logout'><i class="ico-exit"></i> Sair</a>
            </div>
          </div>
          <!-- :::::::::: -->

        </div>
      </header>

      <!-- <div class="row block-responses">
        <div class="col-12 col-md-12 col-lg-4 col-xl-4">
          <p class="user">
            <span>Alexsander,</span>
            Seu perfil está quase completo
          </p>
          <p class="response">
            Já confirmamos sua conta na IOUU e para você começar a investir, basta concluir seu cadastro de investidor.
          </p>
        </div>
        <div class="col-12 col-md-12 col-lg-8 col-xl-8 steps">
          <ul class="d-flex justify-content-end">
            <li class="step">
              <i class="ico ico__ok"></i>
              <p>Sua conta na IOUU está OK!</p>
            </li>
            <li class="align-self-center">
              <div class="div"></div>
            </li>
            <li class="step">
              <i class="ico ico__investidor"></i>
              <p>Cadastro de Investidor</p>
              <span>
                <router-link to="/informacoes-adicionais/investidor" class="btn btn-sm btn-primary" title="Preencher formulário">Preencher</router-link>
                <span style="display:none;" class="btn btn-sm btn-primary">Em analise</span>
              </span>
            </li>
            <li class="align-self-center next">
              <div class="div"></div>
            </li>
            <li class="step next">
              <i class="ico ico__formulario"></i>
              <p>Formulário de suitability</p>
              <span>
                <router-link to="/informacoes-adicionais/suitability" class="btn btn-sm btn-primary" title="Preencher formulário">Preencher</router-link>
                <span style="display:none;" class="badge badge-warning">Em analise</span>
              </span>
            </li>
            <li class="align-self-center next">
              <div class="div"></div>
            </li>
            <li class="step next">
              <i class="ico ico__investir"></i>
              <p>Apoiar primeiro projeto</p>
            </li>
          </ul>
        </div>
      </div> -->

      <!-- <div class="row">
        <div class="col-12">
          <at-menu mode="horizontal" active-name="1">
            <at-menu-item name="1"><i class="ico-gra-4"></i>Meus investimentos</at-menu-item>
            <at-menu-item name="2"><i class="ico-ps"></i>Oportunidades</at-menu-item>
            <at-menu-item name="3"><i class="ico-imp"></i>Investimento Social</at-menu-item>
            <at-menu-item name="4"><i class="ico-ct"></i>Portfólio</at-menu-item>
          </at-menu>
        </div>
      </div> -->


      <main>
        <transition name="fade" mode="out-in">
          <router-view  />
        </transition>
      </main>

      <!-- FOOTER -->
      <footer class="d-flex justify-content-between">
        <div>
          <a href="/" class="link" title="IOUU">
            <i class="ico-iouu"></i>
            <span>V - {{ version }} © 2020 - IOUU. TODOS OS DIREITOS RESERVADOS.</span>
          </a>
        </div>
        <social-network/>
      </footer>
      <!-- FOOTER -->

    </div>
  </div>
</template>

<style lang="scss" scoped>
	.app-wrapper {
		position: relative;
	}

	.modal {
		p {
			color: #000;
			margin-bottom: 40px;
		}
	}

  .invited-company{
    width: 180px !important;
  }
</style>

<script>
  /* eslint-disable */
  import SocialNetwork from '@/components/SocialNetworkDashboard'
  import SideMenu from '@/components/SideMenu'
  import ApiClient from '../../utils/api-client'
  import * as mutationTypes from '@/store/mutation-types.js'
  import Modal from '@/components/Modal'
  import Friend from '@/components/Invite/Friend'
  import Company from '@/components/Invite/Company'
  import Alerts from  '@/components/Alerts'
	import pkg from '../../../package.json'

  export default {
    metaInfo: {
      htmlAttrs: {
        lang: 'pt-br'
      },
      bodyAttrs: {
        class: 'bg-light'
      }
    },
     data() {
       return {
         version:pkg.version,
         menuItems: [
          //  {iconClass: "ico-din-2", title: "Quero Investir", path: "/investimentos/oportunidades/", title2: "Quero Investir", modal:true},
           {iconClass: "ico-din-3", title: "Meus Empréstimos", path: "/emprestimos/meus-emprestimos"},
           {iconClass: "ico-din-5", title: "Solicitar Empréstimo", url: "https://emprestimos.iouu.com.br/pedido"},
          //  {iconClass: "ico-lib", title: "Meu Histórico", path: "/emprestimos/historico"},
           {iconClass: "ico-ch", title: "Perguntas e Respostas", url: "http://ajuda.iouu.com.br" }
         ],
        showModal: false,
        modalStep: 1,
        auxModalStep: 1,
         model:{
           User:{}
         },
         from: "EMP",
         userId: null,
       }
     },
     components: {
      SideMenu,
      SocialNetwork,
         Modal,
      Friend,
      Company,
      Alerts
    },
    methods: {
      Logout() {
       this.$store.dispatch('logout')
       this.$router.push('/login')
     },
         // METHOD TO SHOW MOBILE MENU
     ShowMobMenu(status) {
       var
          menu = document.getElementsByClassName('collapsed-menu');

       if(status == true && menu.length >= 1) {
         menu[0].classList.add("show");
       }
     },

     finishInvite() {
       this.modalStep = 3;
     },

     activeButton(name) {
       var
          buttonName = name;

          if(buttonName === "person") {
            document.getElementsByClassName('invited-person')[0].classList.add('active');
            document.getElementsByClassName('invited-company')[0].classList.remove('active');
          } else {
            document.getElementsByClassName('invited-person')[0].classList.remove('active');
            document.getElementsByClassName('invited-company')[0].classList.add('active');
          }
     },
     Nome(){
      var nome="", letra = "";
       if(this.User.name == undefined ||this.User.name == null || this.User.name == "")
       {
         nome = this.User.username;
       }else{
         nome = this.User.name;
       }
       nome = nome.trim();
       var primeiroNome = nome.split(" ")[0];

       return primeiroNome[0].toUpperCase() +  primeiroNome.toLowerCase().substring(1);
     },
     LetraNome(){

      var nome  = this.Nome();

      if (nome != null && nome != undefined && nome.length > 0)
          return nome[0].toUpperCase()

        return "";
      }
    },
    computed: {
     User: function() {return this.$store.state.currentUser;}
    },
    beforeCreate() {

   }

   }
</script>



// WEBPACK FOOTER //
// src/views/layouts/LoansLayout.vue